import { DocumentRange } from '../services/document-requirements.service';

/**
 * Floor rule: the active range with the greatest `minUsd` <= amountUsd.
 * Below the lowest min -> null (no documentation block); above the top max
 * -> top range. `maxUsd` is display-only.
 */
export function selectRangeForAmount(
  ranges: DocumentRange[],
  amountUsd: number,
): DocumentRange | null {
  if (!Number.isFinite(amountUsd)) {
    return null;
  }
  let selected: DocumentRange | null = null;
  for (const range of ranges) {
    if (range.minUsd <= amountUsd && (!selected || range.minUsd > selected.minUsd)) {
      selected = range;
    }
  }
  return selected;
}
